import React from 'react';
import { GiftIcon, AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { EbookMockup } from './EbookMockup';
type Bonus = {
  number: string;
  title: string;
  description: string;
  image?: string;
  mockup?: {
    title: string;
    highlight?: string;
    background: string;
  };
};
export function BonusStack() {
  const bonuses: Bonus[] = [{
    number: '01',
    title: 'Guía Antiinflamatoria',
    description: 'Reducí hinchazón, fatiga y pesadez desde adentro con alimentación real.',
    image: 'https://cdn.magicpatterns.com/uploads/ovefJNqAaXqA2RMcz8zpK8/MOCKUP_BONO_ANTIINFLAMACION.png'
  }, {
    number: '02',
    title: 'Stretching y Movilidad',
    description: 'Estiramiento post-entreno y rutinas de alivio de tensiones.',
    image: 'https://cdn.magicpatterns.com/uploads/fBHsNJEtCAAbheMqEs6PrX/MOCKUP_BONO_STRETCHING.png'
  }, {
    number: '03',
    title: 'Sueño y Recuperación',
    description: 'Dormí mejor, recuperate más rápido y despertate con más energía.',
    mockup: {
      title: 'Dormí Mejor y Recuperate',
      highlight: 'En 7 Días',
      background: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=400&h=600&fit=crop'
    }
  }, {
    number: '04',
    title: 'Snacks Saludables',
    description: 'Opciones ricas para antojos, pre y post-entreno sin culpa.',
    image: 'https://cdn.magicpatterns.com/uploads/rhLmgD4kyzFAgDRoAAzSWn/MOCKUP_BONO_SNACKS.png'
  }, {
    number: '05',
    title: 'Meal Prep',
    description: 'Preparás comida para toda la semana en una sola sesión de cocina.',
    image: 'https://cdn.magicpatterns.com/uploads/fPHxvzRNsSn24p7dCmfe8S/MOCKUP_BONO_MEAL_PREP.png'
  }, {
    number: '06',
    title: 'Lista de Supermercado',
    description: 'Lista organizada con ingredientes accesibles. Ahorrás tiempo y dinero.',
    image: 'https://cdn.magicpatterns.com/uploads/hxVHng7TmjtRtpVCr6PP31/MOCKUP_LISTA_SUPER.png'
  }, {
    number: '07',
    title: '54 Recetas Saludables',
    description: 'Desayunos, almuerzos, cenas y postres sin cocinar complicado.',
    image: 'https://cdn.magicpatterns.com/uploads/efyMyLTf4pqAhVc6mxRwKb/MOCKUP_BONO_54_RECETAS.png'
  }, {
    number: '08',
    title: 'Hábitos Duraderos',
    description: 'Sistema para mantener resultados sin abandonar a la semana.',
    image: 'https://cdn.magicpatterns.com/uploads/pz9waFDCtPvdzjvU58KyxS/MOCKUP_BONO_HABITOS.png'
  }, {
    number: '09',
    title: 'Licuados e Infusiones',
    description: 'Smoothies y aguas para energía, hidratación y recuperación.',
    image: 'https://cdn.magicpatterns.com/uploads/hY9xi9o9AP4JGNS526ZbJX/MOCKUP_GUIA_DE_BATIDOS.png'
  }, {
    number: '10',
    title: 'Alimentación Completa',
    description: 'Plan de comidas de 14 días para tonificar, bajar grasa y tener más energía.',
    image: 'https://cdn.magicpatterns.com/uploads/dwkRUQUL97ugAoMMtN4maX/MOCKUP_BONO_14_DIAS_DE_COMIDA.png'
  }];
  const mainProductValue = 19990;
  const bonusValue = 11990;
  const totalValue = mainProductValue + bonuses.length * bonusValue;
  const finalPrice = 16990;
  return <section className="py-12 md:py-16 bg-white" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-17">

        {/* Header */}
        <div className="text-center mb-8" data-id="element-18">
          <div className="inline-block bg-brand-pink-600 text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide mb-3" data-id="element-19">
            Todo incluido
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-2" data-id="element-20">
            Lo que te llevás hoy
          </h2>
          <p className="text-gray-600 text-base max-w-xl mx-auto" data-id="element-21">
            El programa principal + 10 bonos gratis. Todo accesible desde tu celular apenas comprás.
          </p>
        </div>

        {/* Producto principal */}
        <div className="bg-brand-pink-50 border-2 border-brand-pink-200 rounded-2xl p-5 mb-4 flex items-center gap-4 max-w-2xl mx-auto" data-id="element-22">
          <div className="w-16 h-20 flex-shrink-0" data-id="element-23">
            <img src="https://cdn.magicpatterns.com/uploads/jUEkp9AcBEThFUJD4CKtwQ/PORTADA_SHOPPY.png" alt="Programa principal" className="w-full h-full object-contain drop-shadow-md" data-id="element-24" />
          </div>
          <div className="flex-1" data-id="element-25">
            <div className="inline-block bg-brand-pink-600 text-white px-2 py-0.5 rounded text-[10px] font-bold tracking-wide mb-1" data-id="element-26">
              PROGRAMA PRINCIPAL
            </div>
            <h3 className="font-bold text-gray-900 text-sm leading-tight mb-1" data-id="element-27">
              Wall Pilates 28 Días — Programa Completo + Videos
            </h3>
            <p className="text-xs text-gray-500 leading-snug" data-id="element-28">
              28 días de rutinas organizadas con videos demostrativos paso a paso. Incluye plan de alimentación.
            </p>
          </div>
          <div className="text-right flex-shrink-0" data-id="element-29">
            <p className="text-xs text-gray-400 line-through" data-id="element-30">${mainProductValue.toLocaleString('es-AR')}</p>
            <p className="text-sm font-bold text-brand-pink-600" data-id="element-31">INCLUIDO</p>
          </div>
        </div>

        {/* Bonos */}
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-3 max-w-2xl mx-auto mb-10" data-id="element-32">
          {bonuses.map((bonus, i) => <div key={i} className="bg-gray-50 rounded-xl p-3 border border-gray-100 flex items-center gap-3" data-id="element-33">
              <div className="w-12 h-16 flex-shrink-0 flex items-center justify-center" data-id="element-34">
                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain drop-shadow-sm" data-id="element-35" /> : bonus.mockup ? <EbookMockup title={bonus.mockup.title} highlight={bonus.mockup.highlight} background={bonus.mockup.background} className="w-full h-full" data-id="element-36" /> : null}
              </div>
              <div className="flex-1 min-w-0" data-id="element-37">
                <div className="flex items-center gap-1 mb-0.5" data-id="element-38">
                  <span className="bg-brand-pink-600 text-white px-1.5 py-0.5 rounded text-[9px] font-bold" data-id="element-39">BONO {bonus.number}</span>
                </div>
                <h3 className="text-xs font-bold text-gray-900 leading-tight" data-id="element-40">{bonus.title}</h3>
                <p className="text-[11px] text-gray-500 leading-snug line-clamp-2" data-id="element-41">{bonus.description}</p>
              </div>
              <div className="text-right flex-shrink-0 pl-1" data-id="element-42">
                <p className="text-[10px] text-gray-400 line-through" data-id="element-43">${bonusValue.toLocaleString('es-AR')}</p>
                <p className="text-xs font-bold text-emerald-600" data-id="element-44">GRATIS</p>
              </div>
            </div>)}
        </div>

        {/* Resumen de valor — caja oscura */}
        <div className="bg-gray-900 text-white rounded-3xl p-8 md:p-10 max-w-2xl mx-auto text-center border border-brand-pink-600/30" data-id="element-45">

          <p className="text-xs uppercase tracking-widest text-gray-400 mb-4" data-id="element-46">Resumen de lo que te llevás</p>

          {/* Líneas de valor */}
          <div className="space-y-2 mb-6 text-left max-w-xs mx-auto" data-id="element-47">
            <div className="flex justify-between items-center" data-id="element-48">
              <span className="text-sm text-gray-300" data-id="element-49">Programa Wall Pilates 28 días</span>
              <span className="text-sm text-gray-400 line-through" data-id="element-50">${mainProductValue.toLocaleString('es-AR')}</span>
            </div>
            {bonuses.map((b, i) => <div key={i} className="flex justify-between items-center" data-id="element-51">
                <span className="text-xs text-gray-400" data-id="element-52">Bono {b.number}: {b.title}</span>
                <span className="text-xs text-gray-500 line-through" data-id="element-53">${bonusValue.toLocaleString('es-AR')}</span>
              </div>)}
            <div className="border-t border-gray-700 pt-2 flex justify-between items-center" data-id="element-54">
              <span className="text-sm font-bold text-gray-200" data-id="element-55">Valor total real</span>
              <span className="text-sm font-bold text-gray-400 line-through" data-id="element-56">${totalValue.toLocaleString('es-AR')}</span>
            </div>
          </div>

          <p className="text-xs uppercase tracking-widest text-brand-pink-400 font-bold mb-1" data-id="element-57">Hoy te lo llevás por</p>
          <p className="text-7xl md:text-8xl font-black text-brand-pink-500 leading-none mb-1" data-id="element-58">
            $16.990
          </p>
          <p className="text-sm text-brand-pink-300 mb-2" data-id="element-59">ARS</p>

          <div className="inline-flex items-center gap-2 bg-yellow-400 text-gray-900 px-5 py-2 rounded-full text-base font-extrabold mb-6" data-id="element-60">
            💰 AHORRÁS ${(totalValue - finalPrice).toLocaleString('es-AR')} — 88% OFF
          </div>

          <div className="mb-6" data-id="element-61">
            <CTAButton size="large" data-id="element-62">QUIERO EMPEZAR — $16.990</CTAButton>
          </div>

          <p className="text-xs text-gray-400" data-id="element-63">
            🛡️ Garantía 7 días · Acceso inmediato · Desde el celular
          </p>
        </div>

      </div>
    </section>;
}